// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.dataTable tbody tr.selected {
    color: white;
    background-color: grey !important;
    box-shadow: none;
}

table.dataTable tbody tr:hover {
    background-color: var(--primary-color) !important;
    box-shadow: none;
}

.dataTables_wrapper {
    /*display:flex;
    flex-direction:column;
    flex: 1 1 auto;*/
    height: 100%;
}

.dataTables_scroll {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    height: 100%;
}

.dataTables_scrollBody {
    flex: 1 1 auto;
}

.dataTables_scrollHead {
    min-height: 40px;
}

.dataTables_info {
    display: none;
}

.dataTables_paginate {
    display: none;
}

.dataTables_filter {
    display: none;
}

.tfoot {
    display: table-header-group;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/jobs/joblogs/jobs.logs.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA;IACI;;oBAEgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["table.dataTable tbody tr.selected {\n    color: white;\n    background-color: grey !important;\n    box-shadow: none;\n}\n\ntable.dataTable tbody tr:hover {\n    background-color: var(--primary-color) !important;\n    box-shadow: none;\n}\n\n.dataTables_wrapper {\n    /*display:flex;\n    flex-direction:column;\n    flex: 1 1 auto;*/\n    height: 100%;\n}\n\n.dataTables_scroll {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    height: 100%;\n}\n\n.dataTables_scrollBody {\n    flex: 1 1 auto;\n}\n\n.dataTables_scrollHead {\n    min-height: 40px;\n}\n\n.dataTables_info {\n    display: none;\n}\n\n.dataTables_paginate {\n    display: none;\n}\n\n.dataTables_filter {\n    display: none;\n}\n\n.tfoot {\n    display: table-header-group;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
